module.exports = __webpack_public_path__ + "static/img/icon_cdb.29f62551.png";